// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iFUto","newExpiryDate":"styles_newExpiryDate__8ng21","footer":"styles_footer__3QvMw"};